import { render, staticRenderFns } from "./MyPagesLayout.vue?vue&type=template&id=646b8500"
import script from "./MyPagesLayout.vue?vue&type=script&lang=js"
export * from "./MyPagesLayout.vue?vue&type=script&lang=js"
import style0 from "./MyPagesLayout.vue?vue&type=style&index=0&id=646b8500&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports